import Login from '../views/Login.vue'

export const LOGIN_ROUTE_PATH = '/login'
export const LOGIN_ROUTE_NAME = 'Login'

const ROUTES = [
  {
    path: LOGIN_ROUTE_PATH,
    name: LOGIN_ROUTE_NAME,
    meta: {
      hideNav: true,
      displayLink: false
    },
    component: Login
  }
]

export default async () => {
  return ROUTES
}
